import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { logout } from '@/lib/api';
import { setActivePropertyId } from '@/lib/auth';
import { useHealth } from '@/lib/queries';

export default function SystemTab() {
  const health = useHealth();
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader className="pb-2 space-y-1">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            Connection
          </p>
          <CardTitle className="font-display text-base">API health</CardTitle>
          <CardDescription>
            {health.isLoading
              ? 'Pinging…'
              : health.isError
                ? 'Unreachable'
                : `OK · ${health.data ? new Date(health.data.ts).toLocaleString() : ''}`}
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0 space-y-1 font-mono text-xs text-muted-foreground">
          <p>API base · {window.location.origin}/api</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2 space-y-1">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            Session
          </p>
          <CardTitle className="font-display text-base">Sign out</CardTitle>
          <CardDescription>
            Clears your session and redirects to sign-in.
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <Button
            variant="secondary"
            onClick={async () => {
              try {
                await logout();
              } catch {
                /* ignore */
              }
              setActivePropertyId(null);
              window.location.assign('/auth/sign-in');
            }}
            data-testid="settings-sign-out"
          >
            Sign out
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2 space-y-1">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            Operational
          </p>
          <CardTitle className="font-display text-base">Backup</CardTitle>
          <CardDescription>
            Snapshots prod D1 + R2 to ./backups. Run on a schedule or before a risky migration.
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <pre className="rounded-md border border-rule bg-muted/60 p-3 text-[12px] font-mono leading-relaxed overflow-x-auto">
{`make backup        # writes ./backups/<timestamp>/`}
          </pre>
        </CardContent>
      </Card>
    </div>
  );
}
